import FlagsDetails from '../../../../patient/details/flags/FlagsDetails'

export default function FlagsDrawerTab({ classes, column = 5, inWorkQ }) {
    const embedded = inWorkQ?.case_flag ?? null
    return (
        <div className={`${classes.block} ${classes[`block_${column}`]}`}>
            <FlagsDetails embeddedCaseFlag={embedded} skipRemoteFetch />
        </div>
    )
}
